import { DOCUMENT_TYPE_FILTER } from '../actions';
import '../global';


export default function document_type_filter_reducer( state = [], action ) {
	switch ( action.type ) {
		case DOCUMENT_TYPE_FILTER:
			if (state.includes(action.payload)) {
				return state.filter(item => item !== action.payload);
			} else {
				return [...state, action.payload];
			}
		default:
			return state;
	}
}